import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { FiCalendar, FiMail } from 'react-icons/fi';
import { FaInstagram } from 'react-icons/fa';
import './MarketingPage.css';

export default function MarketingPage() {
  return (
    <div className="marketing-page">
      <nav className="marketing-main-tabs" aria-label="Marketing">
        <NavLink to="/marketing" end className={({ isActive }) => (isActive ? 'active' : '')}>
          <FiCalendar /> Kalender
        </NavLink>
        <NavLink to="/marketing/instagram" className={({ isActive }) => (isActive ? 'active' : '')}>
          <FaInstagram /> Instagram
        </NavLink>
        <NavLink to="/marketing/popup" className={({ isActive }) => (isActive ? 'active' : '')}>
          <FiMail /> Pop-up
        </NavLink>
      </nav>
      <Outlet />
    </div>
  );
}
